/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';
import directDebitIcon from 'assets/images/direct-debit_ewDqbihq.svg';

/**
 * Style dependencies
 */
import './styles.scss';

const PaymentMethodIcon = ({ type }) => {
    const getIcon = (type) => {
        switch (type) {
            case 'visa':
                return { type: 'fa', name: 'FaCcVisa' };
            case 'mastercard':
                return { type: 'fa', name: 'FaCcMastercard' };
            case 'american_express':
                return { type: 'fa', name: 'FaCcAmex' };    
            default:
                return { type: 'fa', name: 'FaCreditCard' };
        }
    };

    if (type == 'direct_debit') {
        return <img className='card__options__icon--dd' src={directDebitIcon} alt='Direct debit' />;
    }
    
    return <Icon className='card__options__icon' {...getIcon(type)} />;
};

export default PaymentMethodIcon;
